import React from 'react'
import banner from '../../assets/img/banner-bg.jpg'
import { useNavigate } from 'react-router-dom'

const Sell = () => {
  const navigate = useNavigate()
  return (
    <div className="py-16 overflow-hidden relative">
      <div className="absolute top-0 flex w-full h-full bg-gradient-to-r from-indigo-500 to-emerald-500 overflow-hidden">
        <img src={banner} className="opacity-60 min-h-full object-cover w-full" />
      </div>
      <div className="absolute w-full h-full bg-black top-0 opacity-50"></div>
      <div className="innerContainer mx-auto z-10 relative text-white text-center space-y-6 py-5">
        <div className="space-y-2">
          <h2 className="text-4xl lg:text-5xl font-bold select-none">Står <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-emerald-600 bg-pos-0 bg-size-200">dine bøger</span> og samler støv?</h2>
          <p className="text-xl lg:text-2xl">Sæt dine bøger til salg på få minutter</p>
        </div>
        <button onClick={() => navigate('/sælgBog')} className="select-none text-nowrap bg-size-200 bg-pos-0 hover:bg-pos-100 justify-center w-auto px-4 py-2 text-sm sm:text-base font-medium leading-5 text-white transition-all duration-150 ease-in-out bg-gradient-to-r from-emerald-600 to-emerald-700" type="button" aria-haspopup="true" aria-expanded="true" aria-controls="headlessui-menu-items-117">
          <span>Kom i gang</span>
        </button>
      </div>
    </div>
  )
}

export default Sell